const Colors = {
  primary: '#376BDE',
  mainText: '#1E293B',
  subText: '#797979',
  description: '#64748B',
  placeholder: '#94A3B8',
  backgroundMenuColor: '#376BDE',
  backgroundMiniMenuColor: '#022174',
  backgroundMiniMenuColorHover: '#15317C',
  backgroundWarning: '#fae7d1',
  backgroundError: '#FFA3B0',
  menuText: '#E2E8F0',
  line: '#E2E8F0',
  white: '#FFFFFF',
  red: '#F43F5E',
  orange: '#FC9E12',
  green: '#27AE60',
  yellow: '#FBD301',
  backgroundRichEditor: '#F1F5F9',
  backgroundSuccess: '#c1f1d5',
  loading: '#03045E',
  btnErrorHover: '#d90d2f',
  btnPrimaryHover: '#007399',
  brightGray: '#E9E9E9',
};

export default Colors;
